module.exports = __webpack_public_path__ + "img/authentication.c272247c.jpg";